<template>
  <v-container fluid>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="dialogForm = true">Asociar cuenta</v-btn>
    </v-card-title>
    <v-data-table 
      :headers="headersUsers"
      :items="array_usuarios"
      :items-per-page="10"
      :search="search"
      class="elevation-1">
      <template v-slot:[`item.action`]="{ item }">
        <v-btn fab x-small @click="editUser(item)" class="mr-2">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn fab x-small @click="showRoles(item)" class="mr-2">
          <v-icon>mdi-account-group</v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.estado`]="{ item }">
        <v-chip v-if="item.estado == 'ACTIVO'" x-small color="success" text-color="white"> Activo </v-chip>
        <v-chip v-else x-small color="red" text-color="white"> Inactivo </v-chip>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogForm" persistent max-width="700px">
      <v-card>
        <v-card-title class="headline">
          <span v-if="es_nueva">Asociar cuenta</span>  
          <span v-if="!es_nueva">Actualizar cuenta</span>  
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field 
              type="email"
              v-model="correo"
              label="Correo electrónico"
              :rules="emailRules" 
              required>
            </v-text-field>
            <v-switch
              v-if="!es_nueva"
              v-model="estado"
              color="success"
              hide-details
            >
              <template  v-slot:label>
                <span v-if="estado"> <b>Usuario activo</b></span>
                <span v-else>Usuario inactivo</span>
              </template>
            </v-switch>
            
            
            <v-switch
              v-if="!es_nueva"
              v-model="reiniciar"
              color="success"
              hide-details
            >
              <template v-slot:label>
                <span v-if="reiniciar"> <b>Se colocará la clave predeterminada </b></span>
                <span v-else>Activar para colocar la clave predeterminada </span>
              </template>
            </v-switch>
            
            
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="resetUser"> Cerrar </v-btn>
          <v-spacer></v-spacer>
          <v-btn :disabled="!valid" :loading="loading" v-if="es_nueva" color="primary" class="mr-4" @click="saveUser"> 
            Grabar 
          </v-btn>
          <v-btn :disabled="!valid" :loading="loading" v-if="!es_nueva" color="primary" class="mr-4" @click="updateUser"> 
            Actualizar 
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogRoles" persistent max-width="700px">
      <v-card>
        <v-card-title class="headline">
          <span>Roles | {{ current_user.correo}}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="formRoles" v-model="validRoles" lazy-validation>
            <v-select
              v-model="role_name"
              :items="array_roles_obj"
              item-text="name"
              item-value="name"
              :rules="[rules.required]" 
              label="Rol"
              ></v-select>
          </v-form>
          <v-list dense>
            <v-list-item v-for="(roles_, p2) in array_roles" :key="p2" dense>
              <v-list-item-content>
                <v-list-item-title>{{ roles_ }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn x-small fab icon @click="deleteRole(roles_)" color="error">
                  <v-icon>mdi-close-thick</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="dialogRoles = false"> 
            Cerrar 
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveRole()"> 
            Asignar rol
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import axios from "axios";
  export default {
    components: { 

    },
    data () {
      return {
        search: null,
        array_usuarios: [],
        array_roles: [],
        estado: false,
        reiniciar: false,
        valid: true,
        correo: null,
        es_nueva: true,
        dialogForm: false,
        selected_id: null,
        loading:false,
        validRoles: true,
        role_name: null,
        array_roles_obj: [],
        headersUsers: [
          //{ text: 'Id', value: 'id', sortable: false,  },
          { text: 'Correo', value: 'correo', sortable: false },
          { text: 'Estado', value: 'estado', sortable: false },
          { text: 'Acciones', value: 'action', sortable: false }
        ],
        dialogRoles: false,
        current_user: {
          correo: null,
        },
        rules: {
          required: value => !!value || 'Campo Requerido.',
        },
        emailRules: [
          v => !!v || 'Correo requerido',
          v => /.+@.+\..+/.test(v) || 'Correo debe ser valido',
        ],
      }
    },
    mounted() {
      console.log("Usuario.vue");
      this.getUsuarios();
      this.getRoles();
    },
    methods: {
      getUsuarios(){
        let usuarios = axios.get('AgrupadorFirmante/listar?AgrupadorId='+ this.$route.params.id, { 'headers': this.$store.state.user.headers });
        return usuarios.then((callback) =>
        {
          this.array_usuarios = callback.data;
        }).catch((error) => {
          console.log("ERROR EN EL CALLBACK" + error);
        });
      },
      resetUser() {
        this.es_nueva = true;
        this.dialogForm = false;
        this.loading = false;
        this.$refs.form.reset();
      },
      async asyncValidarUsuario() {
        let x = await this.validarUsuario();
        return x;
      },
      validarUsuario(){
        return new Promise((resolve, reject) => {
          let getUser = axios.get('InfoUsuario/existe?correo='+this.correo, { 'headers': this.$store.state.user.headers })
          return getUser.then((callback) => 
          {
            if (callback.status == 200) {
              resolve(true);
            } else {
              this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Usuario no registrado' });
              resolve(false);
            }
          }).catch((error) => {
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Usuario no registrado' });
            resolve(false);
          });
        });
      },
      editUser(user) {
        console.log("editando:");
        console.log(user);
        this.current_user = user;
        this.dialogForm = true;
        this.es_nueva = false;
        this.selected_id =user.id;
        this.correo = user.correo;
        this.estado = (user.estado == 'ACTIVO' ? true :false);
      },
      saveUser() {
        let _this0 = this;
        if (this.$refs.form.validate()) {
          this.asyncValidarUsuario().then(function(callbackuser) 
          {
            if(callbackuser) {
              _this0.loading = true;
              let getuser = axios.post('AgrupadorFirmante/Crear', 
                { 'correo': _this0.correo, 'AgrupadorId':_this0.$route.params.id,  'estado': 'ACTIVO'},
                { 'headers': _this0.$store.state.user.headers }
              )
              return getuser.then((callback) => {
                
                if(callback.status ==201){
                  _this0.resetUser();
                  _this0.getUsuarios();
                  _this0.dialogForm = false;
                  _this0.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Firmante agregado' });
                }
              }).catch((error1) => {
                _this0.dialogForm = true;
                _this0.loading = false;
                _this0.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Error al realizar la operacion 2: ' + error1.response.data });
                console.log(error1.response.data);
              });
            }
          })
        }
      },
      updateUser() {
        console.log("updateUser");
        if (this.$refs.form.validate()) {
          
          this.loading = true;
          this.dialogForm = false;
          if (this.reiniciar) {
               let getuser = axios.post('Usuario/activar_usuario',
              { 'id': this.selected_id, 'user_name': this.correo}, 
              { 'headers': this.$store.state.user.headers } )
          }
          let getuser = axios.put('AgrupadorFirmante/actualizar', 
            { 'id': this.selected_id, 'correo': this.correo, "agrupadorId": this.$route.params.id, 'estado': (this.estado == true? 'ACTIVO': 'INACTIVO')}, 
            { 'headers': this.$store.state.user.headers }
          )

          return getuser.then((callback) => {
            if(callback.status == 200) {
              this.current_user.correo = this.correo;
              this.current_user.estado = (this.estado == true? 'ACTIVO': 'INACTIVO');
              this.resetUser();
              this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Operacion finalizada con éxito.' });
            } else {
              this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Error al realizar la operación' });
              this.loading = false;
            }
          }).catch((error) => {
            console.log(error);
            this.es_nueva = false;
            this.dialogForm = true;
            this.loading = false;
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Error al realizar la operación' });
          });  
        }
        
      },
      getRoles() {
        let getRols = axios.get('Rol/listar', { 'headers': this.$store.state.user.headers });
        return getRols.then((callback) =>
        {
          let _roles = callback.data;
          setTimeout(() => {
            _roles.splice(_roles.findIndex(v => v.name == 'Administrador'), 1);
            this.array_roles_obj = _roles;
          },1000);
        }).catch((error) => {
          console.log("ERROR EN EL CALLBACK" + error);
        });
      },
      showRoles(item){
        this.current_user = item;
        let usuarios = axios.get('Rol/listar_roles_usuario?correo='+ item.correo, { 'headers': this.$store.state.user.headers });
        return usuarios.then((callback) =>
        {
          this.dialogRoles = true;
          this.array_roles = callback.data;
        }).catch((error) => {
          //console.log("ERROR EN EL CALLBACK" + error);
        });
      },
      deleteRole(role) {
        let _this1 = this;
        let getuser = axios.post('Rol/quitar_rol_a_usuario', 
          { 'usuario': this.current_user.correo, 'nombre_rol':role},
          { 'headers': this.$store.state.user.headers }
        )
        return getuser.then((callback) => {
          if(callback.status ==200){
          _this1.showRoles(_this1.current_user);
          _this1.$refs.formRoles.reset();
          }
        }).catch((error1) => {
          console.log(error1.response.data);
        });
      },
      saveRole() {
        let _this0 = this;
        let getuser = axios.post('Rol/asignar_rol_a_usuario', 
          { 'usuario': this.current_user.correo, 'nombre_rol': this.role_name},
          { 'headers': this.$store.state.user.headers }
        )
        return getuser.then((callback) => {
          console.log(callback.data);
          if(callback.status ==200){
            _this0.showRoles(_this0.current_user);
            _this0.$refs.formRoles.reset();
            _this0.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Role asignado con éxito' });
          }
        }).catch((error1) => {
          console.log(error1.response.data);
          _this0.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: error1.response.data });
        });
      },
    }
  }
</script>